import type { FaireProductEntity } from "../../entity_types/product";

export const p_1ovj0mrg2b: FaireProductEntity = {
  token: "p_1ovj0mrg2b",
  type: "product",
  name: "Eucalyptus Mint & Himalayan Salt Large Bath Bomb - 8oz",
  brandToken: "b_7in1nltx4z",
  brandName: "Pure Drop",
  imageUrl:
    "https://cdn.faire.com/fastly/ac6e8370f08ae9699ead20cb9ac476ef1d2f9e9bdc04c243fe603e4fc581636a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d5d7f0bdf0ad5b3e66cdec7b37e0c9ef3ebad2df3b04f48cf7fd57fa5e41ea0.jpeg",
    "https://cdn.faire.com/fastly/91ae19e024a338908525015c8e48d022315234dae30c9e00341ea13f1de5c432.jpeg",
    "https://cdn.faire.com/fastly/041b956ed2dab3743eae639efc504412f0b75fc041b276e90f393664468ab99e.png",
  ],
  priceDollars: 3.85,
  description:
    "Transform your bath into a soothing oasis with our handmade Eucalyptus bath bomb. Infused with pure eucalyptus essential oil, this bath bomb will leave your skin feeling refreshed and rejuvenated.\n\nEucalyptus oil is known for its therapeutic properties, including its ability to promote relaxation, ease stress and tension, and improve respiratory function.\n\n𝐏𝐫𝐨𝐝𝐮𝐜𝐭 𝐍𝐨𝐭𝐞𝐬:\n\n• Allow the bath bomb to fully dissolve in your bath water without holding it.\n• Phtalate, petroleum and paraben-free\n• Only ever tested on willing humans\n• 100% vegan\n• 1 BATH BOMB is about 2.75 inches in diameter, weight 8 oz\n\n𝐆𝐫𝐞𝐚𝐭 𝐟𝐨𝐫:\n\n• Gifting\n• Self-Care\n• Holiday Gifts\n• Moisturizing\n• Sustainable Gifts\n• Natural Gifts\n• Cleansing\n• Gentle on skin\n• All Ages\n• Kids Bath Bomb\n• Surprise Bath Bomb\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭 𝐋𝐢𝐬𝐭𝐬:\n\nsodium bicarbonate, citric acid, corn startch, epsom salt, jojoba oil, sunflower oil, almond oil, coconut oil, olive oil, isopropyl alcohol, poly 80, fragrance, color, pink himalayan salt\n\nhttps://www.puredropshower.com/collections/puredrop-bath-bomb/products/eucalyptus-mint-himalayan-salt-bath-bomb",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:15.778Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
